import { useEffect, useState } from "react";

import { sdkInstance as sdk } from "../MP_NPS_CSAT/Instance";
import { Plugin } from "../MP_NPS_CSAT/Plugin";

export const useServerSettings = () => {
  const [serverSettings, setServerSettings] = useState(null);

  useEffect(() => {
    const fetchServerSettings = () => {
      const matrixSession = sdk.matrixSession;
      const config = new Plugin().getConfig();

      const { defaultSettings, ...customerSettingsPage } =
        config.customerSettingsPage;
      const defaultUserSettings = defaultSettings;
      const serverUserSettings = matrixSession?.serverConfig?.customerSettings;

      const foundSetting = serverUserSettings?.find(
        (setting) => setting.key === customerSettingsPage.settingName,
      );
      const combinedSettings = foundSetting
        ? JSON.parse(foundSetting.value)
        : defaultUserSettings;

      setServerSettings(combinedSettings);
    };

    fetchServerSettings();
  }, []);

  return serverSettings;
};
